export const RoutesString = {
    PageNotFound: "/404",
    Home: `/`,
    SuperCondria: "/supercondria",
    Study: "/study",
    Shop: "/shop",
    FAQ: "/faq",
};
